import { CognitoIdentityProviderClient, GlobalSignOutCommand } from '@aws-sdk/client-cognito-identity-provider';

/**
 * Utility class for handling global sign out operations
 */
class GlobalSignOutUtil {
  constructor() {
    this.client = null;
  }

  /**
   * Initialize the Cognito Identity Provider client
   * @param {string} region - AWS region
   * @returns {CognitoIdentityProviderClient} - Initialized client
   */
  initializeClient(region) {
    if (!this.client) {
      this.client = new CognitoIdentityProviderClient({ region });
    }
    return this.client;
  }

  /**
   * Perform global sign out for a user
   * @param {string} accessToken - User's access token
   * @param {string} region - AWS region
   * @returns {Promise<Object>} - Result of the global sign out operation
   */
  async performGlobalSignOut(accessToken, region) {
    try {
      if (!accessToken) {
        throw new Error('Access token is required for global sign out');
      }

      const client = this.initializeClient(region);
      
      const command = new GlobalSignOutCommand({
        AccessToken: accessToken
      });

      const result = await client.send(command);
      
      return {
        success: true,
        data: result,
        message: 'Global sign out completed successfully'
      };
    } catch (error) {
      console.error('Global sign out error:', error);
      
      return {
        success: false,
        error: error.message || 'Global sign out failed',
        code: error.name || 'UnknownError'
      };
    }
  }

  /**
   * Check if global sign out is supported for the current user
   * @param {Object} user - User object with access token
   * @returns {boolean} - Whether global sign out is supported
   */
  isGlobalSignOutSupported(user) {
    return !!(user && user.accessToken && typeof user.accessToken === 'string' && user.accessToken.trim() !== '');
  }
}

// Export singleton instance
export const globalSignOutUtil = new GlobalSignOutUtil();

// Export the class for testing purposes
export { GlobalSignOutUtil }; 